import type { SeEmailTemplateDto } from "./connect25.email.template.api";

export interface EmailTemplateFormSnapshot {
    templateName: string;
    subject: string;
    bodyHtml: string;
    enabled: boolean;
    editingId?: number;
}

export function sortEmailTemplatesByName(templates: SeEmailTemplateDto[]): SeEmailTemplateDto[] {
    return [...templates].sort((first, second) =>
        (first.templateName ?? "").localeCompare(second.templateName ?? "", undefined, {
            sensitivity: "base",
        }),
    );
}

export function buildEmailTemplatePayload(snapshot: EmailTemplateFormSnapshot): SeEmailTemplateDto {
    const payload: SeEmailTemplateDto = {
        templateName: snapshot.templateName.trim(),
        subject: snapshot.subject,
        bodyHtml: snapshot.bodyHtml,
        enabled: snapshot.enabled,
    };
    const editingId = snapshot.editingId;
    if (editingId != null && Number.isFinite(editingId)) {
        payload.emailTemplateId = editingId;
    }
    return payload;
}

export async function refreshEmailTemplateTable(options: {
    table: { refresh(force: boolean): Promise<void> } | undefined;
    reloadResource: () => Promise<unknown>;
}): Promise<void> {
    if (options.table) {
        await options.table.refresh(true);
    } else {
        await options.reloadResource();
    }
}
